import { useRef, useCallback } from 'react';

const useDebouncedAction = (action, delay) => {
  const handler = useRef(null);

  const cancelAction = useCallback(() => {
    if (handler.current) {
      clearTimeout(handler.current);
    }
  });

  const debouncedAction = useCallback(
    (...params) => {
      cancelAction();

      handler.current = setTimeout(() => action(...params), delay);
    },
    [action, delay]
  );

  return [debouncedAction, { cancelAction }];
};

export default useDebouncedAction;
